(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["radical-used-surf-page"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('surf-match')) {
    customElements.define('surf-match', class extends HTMLElement {
      connectedCallback() {
        this.state = {};
        this.copy = JSON.parse(this.querySelector('[data-match-copy-json]').textContent);
        this.querySelectorAll('button[data-value]').forEach((button) => {
          button.addEventListener('click', () => this.select(button));
        });
      }
      select(button) {
        const group = button.closest('[data-match-group]');
        group.querySelectorAll('button').forEach((item) => item.setAttribute('aria-pressed', 'false'));
        button.setAttribute('aria-pressed', 'true');
        this.state[group.dataset.matchGroup] = button.dataset.value;
        if (this.state.level && this.state.goal) this.renderResult();
      }
      renderResult() {
        const recommendation = this.copy[this.state.goal];
        const result = this.querySelector('[data-match-result]');
        this.querySelector('[data-match-title]').textContent = recommendation.title;
        this.querySelector('[data-match-copy]').textContent = recommendation.copy;
        const message = `Ciao Radical Shop, Radical Match: livello ${this.state.level}, obiettivo ${this.state.goal}. Vorrei un consiglio su una tavola usata.`;
        this.querySelector('[data-match-link]').href = `${this.dataset.whatsapp}?text=${encodeURIComponent(message)}`;
        result.hidden = false;
        result.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'nearest'});
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
